// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Vacancies',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [11, 24, 49, 67, 84],
      pageIdList: [100, 101, 107, 116, 122],
      // data
      websiteData: [],
      submitText: 'Submit CV',
      genderList: [],
      genderList_en: ['Male', 'Female'],
      genderList_cn: ['先生', '小姐'],
      regionList: [],
      regionList_en: ['China', 'Vietnam', 'Cambodia', 'Indonesia'],
      regionList_cn: ['中国', '越南', '柬埔寨', '印尼'],
      websiteData_en: [
          {
              url: require('@/assets/join/job_06.png'),
              name: '104 Manpower Bank',
              target: 'https://www.104.com.tw/company/1a2x6bl6y9?jobsource=jolist_b_relevance',
          },
          {
              url: require('@/assets/join/job_08.png'),
              name: '51 job',
              target: 'https://jobs.51job.com/all/co3157789.html',
          },
          {
              url: require('@/assets/join/job_03.png'),
              name: 'Job Street',
              target: 'https://www.jobstreet.co.id/id/job-search/job-vacancy.php?key=panarub&location=&specialization=&area=&salary=&ojs=3&src=12',
          }
      ],
      websiteData_cn: [
          {
              url: require('@/assets/join/job_06.png'),
              name: '104 人力银行',
              target: 'https://www.104.com.tw/company/1a2x6bl6y9?jobsource=jolist_b_relevance',
          },
          {
              url: require('@/assets/join/job_08.png'),
              name: '前程无忧',
              target: 'https://jobs.51job.com/all/co3157789.html',
          },
          {
              url: require('@/assets/join/job_03.png'),
              name: 'Job Street',
              target: 'https://www.jobstreet.co.id/id/job-search/job-vacancy.php?key=panarub&location=&specialization=&area=&salary=&ojs=3&src=12',
          }
      ],
      departmentData: [],
      departmentData_en: [
        {
          name: 'Development',
          isSelected: true,
        },
        {
          name: 'Industrial Engineering',
          isSelected: false,
        },
        {
          name: 'Quality',
          isSelected: false,
        },
        {
          name: 'Procurement',
          isSelected: false,
        },
        {
          name: 'Production',
          isSelected: false,
        },
        {
          name: 'Human Resources/CSR',
          isSelected: false,
        },
        {
          name: 'IT',
          isSelected: false,
        },
        {
          name: 'Accounting & Finance',
          isSelected: false,
        },
        {
          name: 'Others, .....',
          isSelected: false,
        },
      ],      
      departmentData_cn: [
        {
          name: '开发',
          isSelected: true,
        },
        {
          name: '工业工程',
          isSelected: false,
        },
        {
          name: '品管',
          isSelected: false,
        },
        {
          name: '采购',
          isSelected: false,
        },
        {
          name: '生产',
          isSelected: false,
        },
        {
          name: '企业社会责任',
          isSelected: false,
        },
        {
          name: 'IT',
          isSelected: false,
        },
        {
          name: '财务',
          isSelected: false,
        },
        {
          name: '其他',
          isSelected: false,
        },
      ],
      doYouKnowData: [],
      doYouKnowData_en: ['TV', 'Facebook', 'Instagram', 'Wechat', 'Offical website', 'Family/Friends', 'Other'],
      doYouKnowData_cn: ['电视', '脸书', 'Instagram', '微信', '集团官网', '家人朋友', '其他'],
      depOthersStatus: false,
      knowOthersStatus: false,
      submitStatus: false,
      websiteStatus: false,
      fileName: '',
      form: {
        gender: 'Male',
        firstName: '',
        lastName: '',
        email: '',
        Language1: '',
        Language2: '',
        region: 'China',
        department: '',
        departmentOther: '',
        doYouKnow: 'TV',
        doYouKnowOther: '',
        file: '',
      },
      swiperSlides: '',
      pageInfo: '',
      pageName: '',
      pageName_en: {
        submitBth: 'Submit CV',
        applyBth: 'Apply From Local Website',
        popupName: 'Recruitment website',
        basicTitle: 'Basic info',
        gender: 'Gender',
        fullName: 'Full Name',
        email: 'E-mail',
        firstSt: '1st Language',
        secondSt: '2nd Language',
        country: 'What country are you interested in?',
        department: 'Which department are you interested in?',
        know: 'How do you know EP Group?',
        upload: 'Upload resume',
        file: 'file name',
        xing: 'First Name',
        ming: 'Last Name',        
        choose: 'Choose file',
        tips: '(PDF &amp; Word only, under 5MB)',
      },
      pageName_cn: {
        submitBth: '上传简历',
        applyBth: '从网站申请',
        popupName: '招募网站',
        basicTitle: '基本资料',
        gender: '性别',
        fullName: '全名',
        email: '邮箱',
        firstSt: '第一语言',
        secondSt: '第二语言',
        country: '有兴趣的工作地点',
        department: '有兴趣的服务单位',
        know: '通过什么管道认识EP集团?',
        upload: '上传简历',
        file: '文件名称',
        xing: '姓',
        ming: '名',
        choose: '上传文件',
        tips: '(限小于5MB PDF&Word 的档案)',
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getAdPictureList();
      this.getPageInfo();
      this.initLang();
    },
    initLang() {
      if (this.LangIndex === 1) {
        this.pageName = this.pageName_cn;
        this.genderList = this.genderList_cn;
        this.regionList = this.regionList_cn;
        this.departmentData = this.departmentData_cn;
        this.doYouKnowData = this.doYouKnowData_cn;
        this.form.gender = '先生';
        this.form.region = '中国';
        this.websiteData = this.websiteData_cn;
      } else {
        this.pageName = this.pageName_en;
        this.genderList = this.genderList_en;
        this.regionList = this.regionList_en;
        this.departmentData = this.departmentData_en;
        this.doYouKnowData = this.doYouKnowData_en;
        this.form.gender = 'Male';
        this.form.region = 'China';
        this.websiteData = this.websiteData_en;
      };
      this.initText();
    },
    // 提交按钮
    initText() {
      if (this.LangIndex === 1) {
        this.submitText = '上传简历';
      } else {
        this.submitText = 'Submit CV';
      }
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data[0];
        }
      });
    },
    // 选择gender
    selectGender(value) {
      this.form.gender = value;
    },
    // 选择region
    selectRegion(value) {
    this.form.region = value;
    },
    // 选择Department
    switchDepartment(item, index) {
      if( item.name === 'Others, .....' || item.name === '其他') {
        this.depOthersStatus = !this.depOthersStatus;
      } else {
        const data = this.departmentData;
        data[index].isSelected = !item.isSelected;
        this.departmentData = data;
      }
    },
    // 选择Know
    switchKnow(item) {
      if( item === 'Other' || item === '其他') {
        this.knowOthersStatus = true;
      } else {
        this.knowOthersStatus = false;
      };
      this.form.doYouKnow = item;
    },
    // 上传文件
    pushFile(event) {
      console.log(event);
      // let formData = new FormData();
      // formData.append('file', e.target.files[0]);
      const file = event.target.files[0];
      this.fileName = file.name;
      this.form.file = file;
    },
    // 集合列表数据
    assembleData(arr) {
      let newStr = '';
      arr.forEach((item) => {
        if (item.isSelected) {
          newStr+=`${item.name}, `;
        }
      });
      return newStr;
    },
    // 提交数据
    submitForm() {
      // console.log(this.form);
      if (this.LangIndex === 1) {
        this.submitText = '上传中，请稍等...';
      } else {
        this.submitText = 'Submitting. Please wait...';
      };
      this.form.department = this.assembleData(this.departmentData);
      let formData = new FormData();
      for(var key in this.form){
				formData.append(key, this.form[key])
      };
      formData.append('lang', this.language);
      ModelService.postResumeInfo(formData).then((res) => {
        if (res.code === 0) {
          this.initText();
          this.submitStatus = false;
          let successName = '提交成功！';
          this.LangIndex === 1 ? successName = '提交成功！' : successName = 'submit successfully！';
          this.$message.success(successName);
        } else {
          let errorName = '提交失败！';
          this.LangIndex === 1 ? errorName = '提交失败！' : errorName = 'submit failed！';
          this.$message.error(errorName);
        }
      });
    },
    openSubmit() {
      this.submitStatus = true;
    },
    closeSubmit() {
      this.submitStatus = false;
    },
    openWebsite() {
      this.websiteStatus = true;
    },
    closeWebsite() {
      this.websiteStatus = false;
    },
  },
};
